import { render, staticRenderFns } from "./BodyPartsSpeedSegment.vue?vue&type=template&id=7978ca56&"
import script from "./BodyPartsSpeedSegment.vue?vue&type=script&lang=js&"
export * from "./BodyPartsSpeedSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports